import { render, staticRenderFns } from "./OfferRegulations.vue?vue&type=template&id=53b7b748&"
import script from "./OfferRegulations.vue?vue&type=script&lang=js&"
export * from "./OfferRegulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports